module.exports = __webpack_public_path__ + "static/media/mantencionhome.9d044ed2.png";